var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M5 21V4M5 4.4c.7-.25 1.45-.3 2.25 0 1.2.4 2.25 1 3.75 1 1.2 0 2.15-.4 3.05-.8.6-.25 1.25-.5 2-.5.5 0 .95.4.95.95v7.5c0 .4-.22.72-.58.88-.8.35-1.5.67-2.42.67-1.2 0-2.15-.4-3.05-.8-.95-.4-1.9-.8-3.2-.8-1.05 0-1.9.32-2.6.62-.2.1-.4 0-.4-.3V4.4z"
  })));
};
export default SvgFlag;